var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconProfileHeart = function SvgIconProfileHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4c1.28 0 2.509.509 3.414 1.414L12 6l.586-.586A4.829 4.829 0 0 1 16 4c2.761 0 5 2.236 5 4.997V9.5c0 3.816-6.476 8.87-8.441 10.316a.937.937 0 0 1-1.118 0C9.476 18.37 3 13.315 3 9.5v-.502A4.998 4.998 0 0 1 8 4Z",
    stroke: "#000",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })));
};
export default SvgIconProfileHeart;